<template>
  <div class="accordion">
    <button class="accordion-btn d-flex" @click="toggle">
      <div>
        {{ title }}
      </div>
      <div class="ms-auto">
        <ArrowDownIcon/>
      </div>

    </button>
    <div v-if="isOpen" class="accordion-content" v-html="content"></div>
  </div>
</template>

<script>
import ArrowDownIcon from "@/components/Common/Icons/ArrowDownIcon.vue";

export default {
  components: {ArrowDownIcon},
  props: {
    title: String,
    content: String
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>

<style lang="scss" scoped>
.accordion {
  width: 100%;
}

.accordion-btn {
  width: 100%;
  padding: 15px 30px;
  font-family: $font-bold;
  text-transform: uppercase;
  font-size: 14px;
  text-align: left;
  background-color: $color-white;
  color: $color-brown;
  border: none;
  cursor: pointer;
  transition: 0.5s ease-in-out;
  border-radius: 30px;
}

.accordion-btn:hover {
  background-color: $color-blue-accent;
  color: $color-white;
}

.accordion-content {
  padding: 10px;
  border-top: none;
  font-size: 14px;
  font-family: $font-semi-bold;
}

@media screen and (min-width: 1200px) {
  .accordion-btn {
    font-size: 22px;
  }
  .accordion-content {
    font-size: 18px;
  }
}
</style>
